<div class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-px-3 tw-pb-2 tw-text-center">
  <div
    class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-w-full tw-rounded-2xl tw-bg-white/40 dark:tw-bg-white/[0.06] tw-p-6"
    role="status"
    aria-live="polite"
  >
    <mat-spinner diameter="48" aria-hidden="true"></mat-spinner>
    <div class="tw-flex tw-flex-col tw-gap-1">
      <span class="tw-font-semibold tw-text-xl tw-tracking-[-0.1px] tw-text-color-text-default">
        {{ "confirmingPayment" | i18n }}
      </span>
      <span class="tw-text-sm tw-font-medium tw-text-color-text-secondary">
        {{ "confirmingPaymentDesc" | i18n }}
      </span>
    </div>
  </div>
</div>
